import { ArrowDirRight } from "@/assets/svg";

import styles from "./BackToLobbyButton.module.scss";
import { useTranslation } from "react-i18next";
import { safeSessionStorage } from "@/utils";

const BackToLobbyButton = ({ ...props }) => {
  const returnUrl = safeSessionStorage.getItem("returnUrl");
  const { t } = useTranslation();
  if (!returnUrl) return null;

  return (
    <button
      {...props}
      onClick={() => {
        safeSessionStorage.removeItem("returnUrl");
        window.location.href = returnUrl;
      }}
      className={`${props.className} ${styles.button} flex align-items-center justify-content-center gap-1 p-2 border-round-lg text-sm font-semibold cursor-pointer border-none text-color`}
    >
      <ArrowDirRight style={{ transform: "rotate(180deg)" }} width={20} height={20} />
      <span>{t("casino.hub.cards.back")}</span>
    </button>
  );
};

export default BackToLobbyButton;
